// WCL gear data carries permanentEnchant / temporaryEnchant as ItemEnchantment
// IDs (the database row id, not a spell id). Wowhead doesn't have an
// /enchantment=<id> URL, so we have to translate to the underlying spell id
// before we can show a real name. wowsims/classic ships a database that maps
// the two; we mirror the relevant subset into shared/enchants.json.

import enchantsJson from './enchants.json';

export interface EnchantData {
  spellId: number;
  name: string;        // English name from wowsims db (used as a fallback)
  // Optional. For TEMPORARY weapon enchants (sharpening stones / weight
  // stones / oils), the wowhead spell returns the BUFF name ("致命武器") not
  // the item name ("元素磨刀石") — users want the item name. So we record
  // the consumable's item id here and the gear renderer prefers an item
  // lookup over the spell lookup when this field is present.
  itemId?: number;
}

export const ENCHANTS: Record<string, EnchantData> = enchantsJson as Record<string, EnchantData>;

export function lookupEnchant(effectId: number): EnchantData | null {
  if (!effectId) return null;
  return ENCHANTS[String(effectId)] ?? null;
}
